
import { useState } from "react";
import Login from "./Login";
import Cadastro from "./Cadastro";

function App() {
  const [tela, setTela] = useState("login");

  return (
    <div>
      {tela === "login" ? <Login /> : <Cadastro />}
      <div className="text-center mt-4">
        {tela === "login" ? (
          <button
            onClick={() => setTela("cadastro")}
            className="text-sm text-yellow-600 hover:underline"
          >
            Ainda não tem conta? Cadastre-se
          </button>
        ) : (
          <button
            onClick={() => setTela("login")}
            className="text-sm text-yellow-600 hover:underline"
          >
            Já tem conta? Faça login
          </button>
        )}
      </div>
    </div>
  );
}

export default App;
